<div class="flex flex-col gap-6 w-full p-4">

	<div *ngIf="loading" class="flex justify-center items-center h-64">
		<p-progressSpinner></p-progressSpinner>
	</div>

	<div *ngIf="!loading">
		<h2 class="text-xl font-semibold text-center mt-4">
			{{ translateServ.dictionary['STEP_PAYMENT_TITLE'] || 'Payment Information' }}
		</h2>
		<p class="text-center text-gray-400">
			{{ translateServ.dictionary['STEP_PAYMENT_TEXT'] || 'Enter your payment details below' }}
		</p>

		<p-toast></p-toast>

		<div class="card p-card-modern p-datatable-form">
			<p-table [value]="paymentInfo" [tableStyle]="{'min-width': '85rem'}">

				<!-- HEADER -->
				<ng-template pTemplate="header">
					<tr>
						<th style="width: 15%;">{{ translateServ.dictionary['STEP_TAB_TIT_PAY_TYPE'] || 'Payment Type'
							}}
						</th>
						<th style="width: 20%;">{{ translateServ.dictionary['STEP_TAB_TIT_BANK_OR_CARD'] || 'Bank /
							Card' }}
						</th>
						<th style="width: 20%;">{{ translateServ.dictionary['STEP_TAB_TIT_EXTRA'] || 'Extra Info' }}
						</th>
						<th style="width: 15%;">{{ translateServ.dictionary['STEP_TAB_TIT_ACC_NUM'] || 'Account Number'
							}}
						</th>
						<th style="width: 10%;">{{ translateServ.dictionary['STEP_TAB_TIT_UNIQUE'] || 'Unique/Regular'
							}}
						</th>
						<th style="width: 15%;">{{ translateServ.dictionary['STEP_TAB_TIT_DESC'] || 'Description' }}
						</th>
						<th style="width: 10%;">{{ translateServ.dictionary['STEP_TAB_TIT_ACT_STAT'] || 'Status' }}</th>
						<th style="width: 10%;">{{ translateServ.dictionary['STEP_TAB_TIT_APPROVED'] || 'Approved' }}
						</th>
						<th style="width: 5%;">{{ translateServ.dictionary['STEP_TAB_TIT_ACT'] || 'Actions' }}</th>
					</tr>
				</ng-template>

				<!-- BODY -->
				<ng-template pTemplate="body" let-paymentEntry>
					<tr>
						<!-- Payment Type -->
						<td>
							<p-autoComplete [(ngModel)]="paymentEntry.type" [suggestions]="filteredPaymentTypes"
								(completeMethod)="searchPaymentTypes($event)" [field]="'label'" [dropdown]="true"
								[appendTo]="'body'"
								placeholder="{{ translateServ.dictionary['Select Payment Type'] || 'Select Payment Type' }}"
								[forceSelection]="true" (onSelect)="onPaymentTypeChange($event, paymentEntry)"
								styleClass="p-inputtext-sm w-full">
							</p-autoComplete>
						</td>

						<!-- Shared: Bank / Credit -->
						<td>
							<ng-container *ngIf="paymentEntry.paymentTypeCode === CREDIT_TYPE_CODE">
								<p-autoComplete [(ngModel)]="paymentEntry.creditCardLabel"
									[suggestions]="filteredCreditCardTypes"
									(completeMethod)="searchCreditCardTypes($event)" [field]="'label'" [dropdown]="true"
									[appendTo]="'body'"
									placeholder="{{ translateServ.dictionary['Select Card Type'] || 'Select Card Type' }}"
									[forceSelection]="true" (onSelect)="onCreditCardTypeSelected($event, paymentEntry)"
									styleClass="p-inputtext-sm w-full">
								</p-autoComplete>
							</ng-container>

							<ng-container *ngIf="paymentEntry.paymentTypeCode === BANK_TYPE_CODE">
								<p-autoComplete [(ngModel)]="paymentEntry.bankLabel" [suggestions]="filteredBankNames"
									(completeMethod)="searchBankNames($event)" [field]="'label'" [dropdown]="true"
									[appendTo]="'body'"
									placeholder="{{ translateServ.dictionary['Select Bank'] || 'Select Bank' }}"
									[forceSelection]="true" (onSelect)="onBankSelected($event, paymentEntry)"
									styleClass="p-inputtext-sm w-full">
								</p-autoComplete>
							</ng-container>
						</td>

						<!-- Extra inputs -->
						<td>
							<!-- Credit: last 4 digits -->
							<ng-container *ngIf="paymentEntry.paymentTypeCode === CREDIT_TYPE_CODE">
								<input type="text" pInputText maxlength="4"
									[(ngModel)]="paymentEntry.credit_card_number"
									placeholder="{{ translateServ.dictionary['Enter last 4 digits'] || 'Last 4 digits' }}"
									class="p-inputtext-sm w-full">
							</ng-container>

							<!-- Bank: branch + account -->
							<ng-container *ngIf="paymentEntry.paymentTypeCode === BANK_TYPE_CODE">
								<input type="text" pInputText [(ngModel)]="paymentEntry.bank_branch"
									placeholder="{{ translateServ.dictionary['Enter branch'] || 'Branch Number' }}"
									class="p-inputtext-sm w-full mb-2">
								<input type="text" pInputText [(ngModel)]="paymentEntry.bank_account_number"
									placeholder="{{ translateServ.dictionary['Enter account'] || 'Account Number' }}"
									class="p-inputtext-sm w-full">
							</ng-container>
						</td>

						<td>
							<input type="text" pInputText [(ngModel)]="paymentEntry.paymentAccountNumber"
								placeholder="{{ translateServ.dictionary['Enter account number'] || 'Payment Account Number' }}"
								class="p-inputtext-sm w-full">
						</td>

						<!-- Unique -->
						<td class="text-center">
							<p-tag
								[value]="paymentEntry.uniqueFeature ? (translateServ.dictionary['Unique'] || 'Unique') : (translateServ.dictionary['Regular'] || 'Regular')"
								[severity]="paymentEntry.uniqueFeature ? 'info' : 'warning'"
								(click)="toggleUnique(paymentEntry)">
							</p-tag>
						</td>

						<!-- Description -->
						<td>
							<textarea pInputTextarea [(ngModel)]="paymentEntry.description" [rows]="1"
								[maxlength]="DESCRIPTION_MAX_LENGTH"
								placeholder="{{ translateServ.dictionary['Enter description'] || 'Description' }}"
								class="w-full">
            </textarea>
						</td>

						<!-- Status -->
						<td class="text-center">
							<span (click)="toggleIsActive(paymentEntry)">
								<p-tag
									[value]="paymentEntry.isActive === 1 ? (translateServ.dictionary['Active'] || 'Active') : (translateServ.dictionary['Inactive'] || 'Inactive')"
									[severity]="getSeverity(paymentEntry.isActive === 1)">
								</p-tag>
							</span>
						</td>

						<!-- Approved -->
						<td class="text-center">
							<span (click)="toggleIsApproved(paymentEntry)">
								<p-tag
									[value]="paymentEntry.isApproved === 1 ? (translateServ.dictionary['Approved'] || 'Approved') : (translateServ.dictionary['Pending'] || 'Pending')"
									[severity]="getSeverity(paymentEntry.isApproved === 1)">
								</p-tag>
							</span>
						</td>

						<!-- Actions -->
						<td>
							<div class="flex gap-2">
								<!-- Delete only in create mode -->
								<button *ngIf="isCreate" pButton type="button" icon="pi pi-trash"
									class="p-button-rounded p-button-text p-button-sm p-button-danger"
									(click)="removeEntry(newEntry)"
									[label]="translateServ.dictionary['TOOLTIP_DELETE_ENTRY'] || 'Delete'">
								</button>

								<!-- Apply changes only in edit mode -->
								<button *ngIf="!isCreate" pButton type="button" icon="pi pi-check"
									class="p-button-rounded p-button-text p-button-sm p-button-info"
									(click)="applyRowChanges(newEntry)"
									[label]="translateServ.dictionary['APPLY_CHANGES'] || 'Apply Changes'">
								</button>
							</div>
						</td>
					</tr>
				</ng-template>

				<!-- FOOTER (new entry row) -->
				<ng-template pTemplate="footer" *ngIf="isCreate">
					<tr>
						<!-- Payment Type -->
						<td>
							<p-autoComplete [(ngModel)]="newEntry.type" [suggestions]="filteredPaymentTypes"
								(completeMethod)="searchPaymentTypes($event)" [field]="'label'" [dropdown]="true"
								[appendTo]="'body'"
								placeholder="{{ translateServ.dictionary['Select Payment Type'] || 'Select Payment Type' }}"
								[forceSelection]="true" (onSelect)="onPaymentTypeChange($event, newEntry)"
								styleClass="p-inputtext-sm w-full">
							</p-autoComplete>
						</td>

						<!-- Shared: Bank / Credit -->
						<td>
							<ng-container *ngIf="newEntry.paymentTypeCode === CREDIT_TYPE_CODE">
								<p-autoComplete [(ngModel)]="newEntry.creditCardLabel"
									[suggestions]="filteredCreditCardTypes"
									(completeMethod)="searchCreditCardTypes($event)" [field]="'label'" [dropdown]="true"
									[appendTo]="'body'"
									placeholder="{{ translateServ.dictionary['Select Card Type'] || 'Select Card Type' }}"
									[forceSelection]="true" (onSelect)="onCreditCardTypeSelected($event, newEntry)"
									styleClass="p-inputtext-sm w-full">
								</p-autoComplete>
							</ng-container>

							<ng-container *ngIf="newEntry.paymentTypeCode === BANK_TYPE_CODE">
								<p-autoComplete [(ngModel)]="newEntry.bankLabel" [suggestions]="filteredBankNames"
									(completeMethod)="searchBankNames($event)" [field]="'label'" [dropdown]="true"
									[appendTo]="'body'"
									placeholder="{{ translateServ.dictionary['Select Bank'] || 'Select Bank' }}"
									[forceSelection]="true" (onSelect)="onBankSelected($event, newEntry)"
									styleClass="p-inputtext-sm w-full">
								</p-autoComplete>
							</ng-container>
						</td>

						<!-- Extra inputs -->
						<td>
							<ng-container *ngIf="newEntry.paymentTypeCode === CREDIT_TYPE_CODE">
								<input type="text" pInputText maxlength="4" [(ngModel)]="newEntry.credit_card_number"
									placeholder="{{ translateServ.dictionary['Enter last 4 digits'] || 'Last 4 digits' }}"
									class="p-inputtext-sm w-full">
							</ng-container>

							<ng-container *ngIf="newEntry.paymentTypeCode === BANK_TYPE_CODE">
								<input type="text" pInputText [(ngModel)]="newEntry.bank_branch"
									placeholder="{{ translateServ.dictionary['Enter branch'] || 'Branch Number' }}"
									class="p-inputtext-sm w-full mb-2">
								<input type="text" pInputText [(ngModel)]="newEntry.bank_account_number"
									placeholder="{{ translateServ.dictionary['Enter account'] || 'Account Number' }}"
									class="p-inputtext-sm w-full">
							</ng-container>
						</td>

						<td>
							<input type="text" pInputText [(ngModel)]="newEntry.paymentAccountNumber"
								placeholder="{{ translateServ.dictionary['Enter account number'] || 'Payment Account Number' }}"
								class="p-inputtext-sm w-full">
						</td>

						<!-- Unique -->
						<td class="text-center">
							<p-tag
								[value]="newEntry.uniqueFeature ? (translateServ.dictionary['Unique'] || 'Unique') : (translateServ.dictionary['Regular'] || 'Regular')"
								[severity]="newEntry.uniqueFeature ? 'info' : 'warning'"
								(click)="toggleUnique(newEntry)">
							</p-tag>
						</td>

						<!-- Description -->
						<td>
							<input type="text" pInputText [(ngModel)]="newEntry.description"
								placeholder="{{ translateServ.dictionary['Enter description'] || 'Description' }}"
								class="p-inputtext-sm w-full">
						</td>

						<!-- Status -->
						<td class="text-center">
							<span (click)="toggleIsActive(newEntry)">
								<p-tag
									[value]="newEntry.isActive === 1 ? (translateServ.dictionary['Active'] || 'Active') : (translateServ.dictionary['Inactive'] || 'Inactive')"
									[severity]="getSeverity(newEntry.isActive === 1)">
								</p-tag>
							</span>
						</td>

						<!-- Approved -->
						<td class="text-center">
							<span (click)="toggleIsApproved(newEntry)">
								<p-tag
									[value]="newEntry.isApproved === 1 ? (translateServ.dictionary['Approved'] || 'Approved') : (translateServ.dictionary['Pending'] || 'Pending')"
									[severity]="getSeverity(newEntry.isApproved === 1)">
								</p-tag>
							</span>
						</td>

						<!-- Add -->
						<td>
							<p-button [label]="translateServ.dictionary['ADD'] || 'Add'" icon="pi pi-plus"
								severity="success" styleClass="p-button-text p-button-sm" (onClick)="addEntry()">
							</p-button>
						</td>
					</tr>
				</ng-template>

				<!-- Empty -->
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="8" class="text-center text-gray-500">
							{{ translateServ.dictionary['STEP_PAYMENT_MSG'] || 'No payment records found' }}
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
		<!-- Navigation Buttons -->
		<div class="flex justify-between pt-6">
			<ng-container *ngIf="!isDialogMode">
				<p-button [label]="translateServ.dictionary['BACK']"
					[icon]="dirServ.isRtl() ? 'pi pi-arrow-right' : 'pi pi-arrow-left'"
					[iconPos]="dirServ.isRtl() ? 'right' : 'left'" severity="secondary" (onClick)="goToPreviousStep()">
				</p-button>
				<p-button [label]="translateServ.dictionary['NEXT']"
					[icon]="dirServ.isRtl() ? 'pi pi-arrow-left' : 'pi pi-arrow-right'"
					[iconPos]="dirServ.isRtl() ? 'left' : 'right'" (onClick)="validateAndProceed()">
				</p-button>
			</ng-container>
			<ng-container *ngIf="isDialogMode">
				<p-button [label]="translateServ.dictionary['CANCEL'] || 'Cancel'" [icon]="'pi pi-times'"
					severity="secondary" (onClick)="closeDialog()">
				</p-button>
				<p-button [label]="translateServ.dictionary['SAVE'] || 'Save'" [icon]="'pi pi-save'"
					(onClick)="saveAndSubmit()" [disabled]="paymentInfo.length === 0">
				</p-button>
			</ng-container>
		</div>
	</div>
</div>